/**
 * Class for each value in a category
 */
export class CategoricalItem {
  constructor({ name, value }) {
    this.id = name;
    this.name = name;
    this.value = value;
    this.isActive = false;
  }
}

export class ActiveCategory {
  constructor({
    category_name,
    category_id,
    comparison = "=",
    item_id,
    entity_model_id,
  }) {
    this.id = `${entity_model_id}_${category_id}_${item_id}`;
    this.category_name = category_name;
    this.category_id = category_id;
    this.item_id = item_id;
    this.comparison = comparison;
    this.entity_model_id = entity_model_id;
    this.query = `${category_id} ${comparison} '${item_id}'`;
  }

  /**
   * Checks if the passed object is same as this object
   * @param ActiveCategory
   * @param {String} ActiveCategory.category_id
   * @param {String} ActiveCategory.item_id
   * @param {String} ActiveCategory.entity_model_id
   */
  compare({ id }) {
    if (id && id === this.id) return true;
  }
}
/**
 * Class for creating categorical widget data
 */
export default class Categorical {
  constructor({
    meta,
    entity_type,
    name,
    col_name,
    entity_id,
    entity_name,
    data,
    metrics,
    is_dimension,
    is_measure,
  }) {
    this.id = col_name;
    this.name = name;
    this.col_name = col_name;
    this.entity_id = entity_id;
    this.entity_name = entity_name;
    this.meta = meta;
    this.entity_type = entity_type;
    this.is_dimension = is_dimension;
    this.is_measure = is_measure;
    this.component = is_dimension ? "CategoricalFilter" : "MeasureFilter";

    try {
      this.data = data ? data.map(item => new CategoricalItem(item)) : [];
    } catch (error) {
      console.error(error);
    }

    this.metrics = metrics;
    this.isSelected = false;
  }

  setSelected(isSelected) {
    this.isSelected = isSelected;
  }
}
